export default __webpack_public_path__ + "static/media/realv.6c8e14a6.png";